const state = {
  newbie: true,
  loading: false,
  initialized: false,
  supportEmail: process.env.VUE_APP_SUPPORT_EMAIL
};

const mutations = {
  startLoad: state => {
    state.loading = true;
  },
  endLoad: state => {
    state.loading = false;
  },
  initialize: state => {
    state.initialized = true;
  }
};

export default {
  state,
  mutations
};
